import datasetsTab from './datasetsTab';
import catalogueTab from '../catalogue/layout/catalogueTab';
import datasetDataTab from '../data/layout/datasetDataTab';
import datasetCloneTab from './datasetCloneTab';
import datasetMarkdownTab from '../markdown/layout/datasetMarkdownTab';
import datasetSettingsTab from '../settings/layout/datasetSettingsTab';
import dictionaryMarkdownTab from '../dictionaries/markdown/layout/dictionaryMarkdownTab';
import newDatasetTab from './newDatasetTab';
import datasetTab from './datasetTab';
import datasetHistoryTab from './datasetHistoryTab';
import datasetNotificationsTab from '../notifications/layout/datasetNotificationsTab';
import datasetSubscribersTab from '../subscriptions/layout/datasetSubscribersTab';
import datasetRequestTab from './datasetRequestTab';

export default [
  catalogueTab,
  datasetCloneTab,
  datasetDataTab,
  datasetHistoryTab,
  datasetMarkdownTab,
  datasetNotificationsTab,
  datasetRequestTab,
  datasetSettingsTab,
  datasetSubscribersTab,
  datasetsTab,
  datasetTab,
  dictionaryMarkdownTab,
  newDatasetTab,
];
